angular
    .module("skillBuilderSaaS")
    .directive("customValidator", function () {
    return {
        require: "ngModel",
        link: function (_scope, _element, attr, ctrl) {
            var type = attr.customValidator.toLowerCase();
            ctrl.$parsers.unshift(function (value) {
                var valid = true;
                if (type === "sin") {
                    value = validSinChars(value);
                    valid = isValidSin(value);
                    ctrl.$setValidity("customValidator", valid);
                }
                // if it's valid, return the value to the model,
                // otherwise return undefined.
                return valid ? value : undefined;
            });
            function validSinChars(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, ""); //.replace(/ /g, "");
                    if (transformedInput !== text) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                }
                return text;
            }
            // add a formatter that will process each time the value
            // is updated on the DOM element.
            ctrl.$formatters.unshift(function (value) {
                // validate.
                if (type === "sin") {
                    ctrl.$setValidity("customValidator", isValidSin(value));
                }
                // return the value or nothing will be written to the DOM.
                return value;
            });
        }
    };
    function isValidSin(text) {
        if (!text)
            return false;
        if (text.length !== 9)
            return false;
        var esum = 0;
        var ch_sum = "";
        //var last = text.substring(8, 8 + 1);
        var odd = ((text.substring(0, 0 + 1)) * (1.0) +
            (text.substring(2, 2 + 1)) * (1.0) +
            (text.substring(4, 4 + 1)) * (1.0) +
            (text.substring(6, 6 + 1)) * (1.0) +
            (text.substring(8, 8 + 1)) * (1.0));
        var enumbers = ((text.substring(1, 1 + 1)) +
            (text.substring(3, 3 + 1)) +
            (text.substring(5, 5 + 1)) +
            (text.substring(7, 7 + 1)));
        var i;
        var ch;
        for (i = 0; i < enumbers.length; i++) {
            ch = (enumbers.substring(i, i + 1) * 2);
            ch_sum = ch_sum + ch;
        }
        for (i = 0; i < ch_sum.length; i++) {
            ch = (ch_sum.substring(i, i + 1));
            esum = ((esum * 1.0) + (ch * 1.0));
        }
        return (odd + esum) % 10 === 0;
    }
});
